<template>
  <div>
    <Layout>
      <div slot="left">
        <a-table :custom-row="customRow" :bordered="true" :pagination="false" size="middle" :data-source="configFied">
          <a-table-column title="配置名称">
            <template slot-scope="text, record"> {{ record.title }}({{ record.name }}) </template>
          </a-table-column>
        </a-table>
      </div>
      <div slot="right">
        <RightComponents :selected-key="selectedKey" :selected-value="selectedValue" />
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from './Layout';
import RightComponents from './rightComponents/index.vue';
export default {
  components: { Layout, RightComponents },
  data() {
    return {
      configFied: [
        {
          name: 'pmom',
          title: '产品运营'
        },
        {
          name: 'br_po',
          title: '产品PO'
        },
        {
          name: 'br_technical_manager',
          title: '技术经理'
        },
        {
          name: 'primary_department',
          title: '一级部门'
        },
        {
          name: 'business_department',
          title: '业务部门'
        },
        {
          name: 'big_br_po',
          title: '大数据po'
        }
      ],
      selectedKey: 'pmom',
      selectedValue: null
    };
  },
  computed: {
    configList() {
      const list = [];
      const configMap = this.$store.state.globalConfigList || {};
      for (const item of this.configFied) {
        list.push(item);
      }
      return list;
    }
  },
  mounted() {
    this.selectRow(this.configFied[0]);
  },
  methods: {
    // 自定义行
    customRow(record, index) {
      return {
        style: {
          'background-color': record.name === this.selectedKey ? '#E9F6FE' : '',
          cursor: 'pointer'
        },
        on: {
          // 鼠标单击行
          click: event => {
            // 记录当前点击的行标识
            this.selectRow(record);
          }
        }
      };
    },
    selectRow(record) {
      this.selectedKey = record.name;
      const configMap = this.$store.state.globalConfigList || {};
      const configVal = configMap[this.selectedKey];
      if (configVal) {
        this.selectedValue = JSON.parse(JSON.stringify(configVal));
      } else {
        this.selectedValue = null;
      }
      const _data = this.configFied.find(item => item.name === record.name);
      if (_data) {
        console.log(_data.title);
        this.utils.trackClick({ name: '点击配置节点', lable: _data.title });
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
